import React from 'react';
import { connect } from 'react-redux';
import { Card, CardHeader, CardText } from 'material-ui';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import search from '../../rest';
import Notes from '../NotesComponent';

const SimilarVendors = (props) => {
  const { toKeep, vendors } = props;

  return (<div>
    <h3>Similar Vendors by Name</h3>
    <ul>
      {vendors.map(vendor => <li key={vendor.relayId}>
        <Link to={`/vendors/${vendor.relayId}/`}>{vendor.name}</Link>
          &nbsp;(<Link to={`/vendors/${toKeep}/merge/${vendor.relayId}/`}>merge</Link>)
        </li>)}
    </ul>
  </div>);
};

SimilarVendors.propTypes = {
  toKeep: PropTypes.string.isRequired,
  vendors: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const AmenityPrograms = (props) => {
  const { programs } = props;

  return (<div>
    <h3>Amenity Programs</h3>
    <ul>
      {programs.map((program, index) => <li key={index}>{program}</li>)}
    </ul>
  </div>);
};

AmenityPrograms.propTypes = {
  programs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const Contact = ({ contact }) => {
  const { email, name = '', position = '' } = contact;

  let displayString = email;
  let nameString = name;
  if (position !== '') {
    nameString = `${name} (${position})`;
  }
  if (nameString !== '') {
    displayString = `${nameString} <${email}>`;
  }

  return <span>{displayString}</span>;
};

Contact.propTypes = {
  contact: PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    position: PropTypes.string,
  }).isRequired,
};

const Contacts = ({ contacts }) => <div>
  <h3>Contacts</h3>
  <ul>
    {contacts.map((contact, index) => <li key={index}><Contact contact={contact} /></li>)}
  </ul>
</div>;

Contacts.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const Travelers = ({ travelers }) => <div>
  <h3>Travelers</h3>
  <ul>
    {travelers.map(({ id, fullName }) => <li key={id}>
      <Link to={`/clients/${id}/`}>{fullName}</Link>
    </li>)}
  </ul>
</div>;

Travelers.propTypes = {
  travelers: PropTypes.arrayOf(PropTypes.object).isRequired,
};

@connect(state => ({
  viewport: state.Responsive.get('viewport'),
  windowHeight: state.Responsive.get('windowHeight'),
})
)
export default class VendorDetail extends React.Component {
  static propTypes = {
    viewport: PropTypes.string.isRequired,
    windowHeight: PropTypes.number.isRequired,
    vendor: PropTypes.shape().isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      similarVendors: [],
    };
  }

  componentWillMount() {
    this.findSimilarVendors(this.props.vendor.name);
  }

  componentWillReceiveProps(nextProps) {
    const { vendor: { id: oldId } } = this.props;
    const { vendor: { id: newId, name: newName } } = nextProps;

    if (oldId !== newId) {
      this.findSimilarVendors(newName);
    }
  }

  findSimilarVendors = (name) => {
    search('auto/vendor', name).then((response) => {
      const { objects } = response;
      this.setState({
        similarVendors: objects.filter(({ score }) => score >= 1).map(object => ({
          relayId: object.relayId,
          name: object.name,
          sabreCode: object.sabreCode,
        })),
      });
    }).catch((response) => {
      console.log(response);
    });
  }

  render() {
    const {
      viewport, vendor: {
        name, id, sabreCode, contacts, amenityPrograms, travelers,
        profileNotes,
      }, windowHeight,
    } = this.props;
    const { similarVendors } = this.state;

    const tripColumnStyles = viewport === 'desktop' ?
    {
      height: windowHeight - 64,
      ...styles.columnStyles,
      ...styles.desktopColumnStyles,
    } : {
      height: windowHeight - 64,
      ...styles.columnStyles,
      ...styles.mobileColumnStyles,
    };

    const dupes = similarVendors.filter(
      vendor => vendor.relayId !== id && ((!sabreCode || !vendor.sabreCode) || (
        sabreCode && vendor.sabreCode && sabreCode === vendor.sabreCode))).sort(
      ({ name: name1 }, { name: name2 }) => {
        if (name1 < name2) {
          return -1;
        } else if (name1 > name2) {
          return 1;
        }
        return 0;
      }
    );

    const contactList = contacts ? JSON.parse(contacts) : [];

    return (<Card style={tripColumnStyles}>
      <CardHeader>
        <h1>{name}</h1>
        <p>Sabre Code: {sabreCode || 'unknown'}</p>
      </CardHeader>
      <CardText>
        <Card>
          <CardHeader title='Profile Notes' />
          <CardText>
            <Notes id={id} fieldName='profileNotes' value={profileNotes} />
          </CardText>
        </Card>
        {contactList.length > 0 ? <Contacts contacts={contactList} /> : null}
        {amenityPrograms.length > 0 ? <AmenityPrograms programs={amenityPrograms} /> : null}
        {dupes.length > 0 ? <SimilarVendors toKeep={id} vendors={dupes} /> : null}
        {travelers.length > 0 ? <Travelers travelers={travelers} /> : null}
      </CardText>
    </Card>);
  }
}

const styles = {
  columnStyles: {
    overflow: 'scroll',
    position: 'relative',
  },
  desktopColumnStyles: {
    width: 700,
  },
  mobileColumnStyles: {
    width: '100%',
  },
};



// WEBPACK FOOTER //
// /src/components/Vendors/VendorDetail.js